import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../shared/components/Sifra';
import { icons } from '../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import Indicator from '../../../UI/Indicator/Indicator';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';

const GridProvider = ({ data = [], isLoading, handleClickDokument }) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: '',
      disableExport: true,
      headerName: '',
      width: 20,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <div style={{ position: 'relative', height: '20px', width: '20px' }}>
          <Indicator active={e.row.statusMasine === 'Operativna'} inGrid />
        </div>
      ),
    },
    // { field: 'ceoBrDok', headerName: 'Broj dok.', width: 80 },
    {
      field: 'ceoBrDok',
      headerName: t('docNumber'),
      width: 200,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickDokument(e.row)}
        />
      ),
    },
    {
      field: 'datum',
      headerName: t('sentDate'),

      width: 110,
      renderCell: (e) => formatDateFromDB(e.row.datum),
    },
    { field: 'nazivKupca', headerName: t('client'), width: 400 },
    { field: 'status', headerName: t('status'), width: 120 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
